.root {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacingLg);
}

.loader {
  color: var(--paletteWhite0);
  text-align: center;
  position: absolute;
  left: 0;
  right: 0;
}
